import { render, staticRenderFns } from "./stat-list.vue?vue&type=template&id=62120bf0"
var script = {}
import style0 from "./stat-list.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports